import { configureStore, type Reducer } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import previewReducer from "../slices/previewSlice";
import permissionReducer from "../slices/permissionSlice";
import { createGroupedStorage, createEncryptTransform } from "@workspace/shared";

const appStorage = createGroupedStorage(import.meta.env.VITE_STORAGE_KEY ?? "admin_app");

const secretKey = import.meta.env.VITE_ENCRYPTION_SECRET_KEY ?? "";

export const encryptTransform = createEncryptTransform(secretKey);

const authPersistConfig = {
  key: "auth",
  keyPrefix: "",
  storage: appStorage,
  transforms: [encryptTransform],
};

const previewPersistConfig = {
  key: "previewToken",
  keyPrefix: "",
  storage: appStorage,
  transforms: [encryptTransform],
};

export const store = configureStore({
  reducer: {
    auth: persistReducer(authPersistConfig, authReducer) as Reducer,
    previewToken: persistReducer(
      previewPersistConfig,
      previewReducer
    ) as Reducer,
    permission: permissionReducer,
  },
  devTools: import.meta.env.MODE !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
